export default "__VITE_ASSET__DkY1rl8X__"